import React, { useRef, ChangeEvent } from 'react';
import classNames from 'classnames';
import { FileUploaderProps } from './FileUploader.types';
import styles from './FileUploader.module.scss';

const FileUploader = ({
  children,
  acceptFiles,
  onFileUpload,
  multiple = true,
  className,
  ...rest
}: FileUploaderProps) => {
  const fileRef = useRef<HTMLInputElement>(null);
  const acceptedFiles = acceptFiles?.join(',');

  const loadFile = ({ target }: ChangeEvent<HTMLInputElement>) => {
    const files = target?.files;

    if (files) {
      onFileUpload(files);
    }
  };

  const upload = () => {
    fileRef?.current?.click();
  };

  return (
    <div {...rest} className={classNames(styles.container, className)}>
      <div onClick={upload}>{children}</div>
      <input
        accept={acceptedFiles}
        id="fileUpload"
        multiple={multiple}
        ref={fileRef}
        type="file"
        value=""
        onChange={loadFile}
      />
    </div>
  );
};

export default FileUploader;
